import { mapGetters } from 'vuex'

/**
 * 数据字典 mixin：提供 getDictName(dictKey, value) 方法，
 * 根据字典 key 和 value 返回对应的显示名称。
 *
 * 用法（script）：
 *   import { dictMixin } from '@/utils/columns'
 *
 *   mixins: [dictMixin],
 *
 *   // 在 template 或 methods 中直接调用：
 *   // this.getDictName('statusDict', row.status)
 */
export const dictMixin = {
  computed: {
    ...mapGetters('setting', ['findDataDict']),
  },
  methods: {
    /**
     * 根据字典 key 和 value 返回对应的名称
     * @param {string} dictKey - 字典标识
     * @param {*} value        - 字典值
     * @returns {*} 对应的名称，找不到时返回原始 value
     */
    getDictName(dictKey, value) {
      if (!value) return value
      const list = this.findDataDict(dictKey)
      if (!list) return value
      const item = list.find(i => i.value === value)
      return item ? item.name : value
    },
  },
}

/**
 * 获取审批状态对应的颜色
 * @param {string} status - 审批状态值
 * @returns {string} Ant Design 标签颜色
 */
export function getApproveStatusColor(status) {
  const colorMap = {
    End: 'green',        // 已结束 - 灰色
    Start: 'blue',         // 已开始 - 蓝色
    Processing: 'orange',  // 审核中 - 橙色
    Pass: 'green',         // 已通过 - 绿色
    Create: 'cyan',        // 已创建 - 青色
    Reject: 'red',         // 已驳回 - 红色
    Cancel: 'volcano'      // 已终止 - 火山红
  }
  return colorMap[status] || 'default'
}

/**
 * 已开始、已终止  可编辑可删除
 * 进行中  所有人不可删除编辑
 * 驳回中  所有人不可删除编辑，在审批中完成
 * 已完成  不可删除编辑
 *
 * @param status
 * @returns {boolean}
 */
export function canEditByStatus(status) {
  return status === 'Start' || status === 'Cancel'
}
export function canDeleteByStatus(status) {
  return status === 'Start' || status === 'Cancel'
}

/**
 * 只有管理员有权限编辑
 */
export function canEditByAdmin(status){
  return status === 'End'
}